import * as React from 'react';
import type { SVGProps } from 'react';
const SvgQuestionFull = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-label="Question_full"
    viewBox="0 0 20 20"
    {...props}
  >
    <circle
      cx={10}
      cy={10}
      r={8}
      fill="var(--color-surface-interactive-primary-default)"
    />
    <path
      fill="var(--color-content-inverted-base-primary)"
      fillRule="evenodd"
      d="M10.456 6.9c-.93-.316-1.579.2-1.765.52a.8.8 0 1 1-1.382-.806c.492-.845 1.878-1.836 3.663-1.228a2.7 2.7 0 0 1 1.677 1.667c.245.696.219 1.55-.286 2.2-.483.623-1.007 1.023-1.478 1.247l-.344-.722.344.722a.4.4 0 0 0-.085.058v.242a.8.8 0 0 1-1.6 0v-.307c0-.758.586-1.242.998-1.438.223-.106.556-.338.901-.783.09-.116.154-.367.04-.687a1.1 1.1 0 0 0-.683-.684Z"
      clipRule="evenodd"
    />
    <path
      fill="var(--color-content-inverted-base-primary)"
      d="M11 13.8a1 1 0 1 1-1.999 0 1 1 0 0 1 1.999 0"
    />
  </svg>
);
export default SvgQuestionFull;
